import { createMultiStyleConfigHelpers as i } from "@chakra-ui/react";
import { ThemeColorToken as e } from "../theme-tokens.js";
import { drawerAnatomy as t } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: o, defineMultiStyleConfig: a } = i(t.keys), r = {
  xs: o({ dialog: { maxWidth: "320px" } }),
  // Chakra default
  sm: o({ dialog: { maxWidth: "448px" } }),
  // Chakra default
  md: o({ dialog: { maxWidth: "560px" } }),
  // Custom
  lg: o({ dialog: { maxWidth: "672px" } }),
  // Chakra default
  xl: o({ dialog: { maxWidth: "896px" } })
  // Chakra default
}, l = o({
  dialog: {
    bg: e.Surface,
    color: e.OnSurface
  }
}), n = a({
  baseStyle: l,
  sizes: r
});
export {
  n as drawerConfig
};
